module.exports = __webpack_public_path__ + "static/media/search.d47f2d57.svg";